export const 
	TAGS_LOAD_SUCCESS 			= 'TAGS_LOAD_SUCCESS',
	TAGS_LOAD_ERROR 			= 'TAGS_LOAD_ERROR',

	TAGS_REORDER				= 'TAGS_REORDER',

	TAGS_RECENT_LOAD_REQ		= 'TAGS_RECENT_LOAD_REQ',
	TAGS_RECENT_LOAD_SUCCESS	= 'TAGS_RECENT_LOAD_SUCCESS',
	TAGS_RECENT_LOAD_ERROR		= 'TAGS_RECENT_LOAD_ERROR',

	TAG_RENAME_REQ	 			= 'TAG_RENAME_REQ',
	TAG_RENAME_SUCCESS 			= 'TAG_RENAME_SUCCESS',
	TAG_RENAME_ERROR 			= 'TAG_RENAME_ERROR',

	TAG_REMOVE_REQ 				= 'TAG_REMOVE_REQ',
	TAG_REMOVE_SUCCESS 			= 'TAG_REMOVE_SUCCESS',
	TAG_REMOVE_ERROR 			= 'TAG_REMOVE_ERROR'